import { RestService } from './_rest.service'
import { REST_API_END_POINTS } from './constants'
import {AuthInstance, instance} from '../helpers'
export class AuthenticationService extends RestService {
  constructor() {
    super(REST_API_END_POINTS.AUTHENTICATION)
  }
  static ping() {
    return RestService.call_url_action(
      `${REST_API_END_POINTS.AUTHENTICATION}/ping`,
      'GET'
    )
  }
  static getOtpOptions(payload) {
    return RestService.call_url_action(
      `${REST_API_END_POINTS.AUTHENTICATION}/otp_options`,
      'POST',
      payload
    )
  }
  static verifyOTP(payload) {
    const searchParams = new URLSearchParams();
    searchParams.set('grant_type', 'password')
    searchParams.set('username', payload.username)
    searchParams.set('password', payload.password)
    searchParams.set('otp', payload.otp)
    searchParams.set('email', payload.email)
    searchParams.set('contact_number', payload.contact_number)
    return AuthInstance.post(
      `${REST_API_END_POINTS.AUTHENTICATION}/verify_otp/${payload.otp_uuid}/`,
      searchParams
    )
  }
  static verifyCustomerOTP(payload) {
    return AuthInstance.post(
      `${REST_API_END_POINTS.AUTHENTICATION}/verify_customer_otp/${payload.otp_uuid}/`,
      payload
    )
  }

  static requestOTP(payload) {
    return RestService.call_url_action(
      `${REST_API_END_POINTS.AUTHENTICATION}/generate_otp`,
      'POST',
      payload
    )
  }
  static checkEmailAvailability(payload) {
    return RestService.call_url_action(
      `${REST_API_END_POINTS.AUTHENTICATION}/register/email_taken`,
      'POST',
      payload
    )
  }
  static register(payload) {
    return RestService.call_url_action(
      `${REST_API_END_POINTS.AUTHENTICATION}/register`,
      'POST',
      payload
    )
  }
  static sendUserEmailVerificationRequest(payload) {
    return RestService.call_url_action(
      `${REST_API_END_POINTS.AUTHENTICATION}/user_email_verification`,
      'POST',
      payload
    )
  }
  static approveUserAccount(payload) {
    return RestService.call_url_action(
      `${REST_API_END_POINTS.AUTHENTICATION}/user_account_approve`,
      'POST',
      payload
    )
  }
  static logout() {
    const url = `${REST_API_END_POINTS.AUTHENTICATION}/logout/`
    return RestService.call_url_action(url, 'POST').then((response) => {
      localStorage.clear()
    })
  }
  static initiatePasswordReset(payload) {
    const url = `${REST_API_END_POINTS.AUTHENTICATION}/password/reset/`
    return RestService.call_url_action(url, 'POST', payload)
  }
  static resetPassword(payload) {
    const url = `${REST_API_END_POINTS.AUTHENTICATION}/password/reset/confirm/`
    return RestService.call_url_action(url, 'POST', payload)
  }
  static changePassword(payload) {
    const url = `${REST_API_END_POINTS.AUTHENTICATION}/password_change/`
    return RestService.call_url_action(url, 'POST', payload)
  }
}
